import { useState } from "react";
import { User } from "../model";
import { useAuth } from "@sky/xerxes-client-react";
import { UserService } from "../service";

type UsersStore = {
    users: User[];
    loading: boolean;
    fetchAll: () => void;
    fetchMore: () => void;
    hasMore: () => boolean;
    clear: () => void;
}

const useUsersStore = (): UsersStore => {
    const { token } = useAuth();
    const [loading, setLoading] = useState<boolean>(false);
    const [paginationToken, setPaginationToken] = useState<string | undefined>(undefined);
    const [users, setUsers] = useState<User[]>([]);
    const userService = new UserService(token!);

    const fetchAll = async () => {
        try {
            setLoading(true);
            const response = await userService.fetchAll();
            setUsers(response.results);
            setPaginationToken(response.paginationToken)
        } catch (e) {
            setUsers([]);
            console.error('Error fetching all users', e)
        } finally {
            setLoading(false);
        }
    }

    const fetchMore = async () => {
        try {
            if (paginationToken) {
                setLoading(true);
                const response = await userService.fetchAll(paginationToken);    
                setUsers([...users, ...response.results]);
                setPaginationToken(response.paginationToken)
            }
        } catch (e) {
            setUsers([]);
            console.error('Error fetching all users', e)
        } finally {
            setLoading(false);
        }
    }

    const clear = () => {
        setUsers([]);
        setPaginationToken(undefined);
    }

    const hasMore = () => {
        return paginationToken !== undefined;
    }

    return {
        users, loading, fetchAll, fetchMore, hasMore, clear
    }
}

export default useUsersStore;